/* import Home from "@/pages/Home.vue";
import DownloadPage from "@/pages/DownloadPage.vue";
import ModuleEnv from "@/pages/ModuleEnv.vue";
import GrapeEnv from "@/pages/GrapeEnv.vue";
 */
import About from "@/pages/About.vue";
import Feedback from "@/pages/Feedback.vue";
import Iframe from "@/pages/Iframe.vue";
import LogOff from "@/pages/LogOff.vue";
import sysPermMgmt from "@/pages/sysPermMgmt.vue";
import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: () => import("@/pages/Home.vue"),
  },
  {
    path: "/envList",
    component: () => import("@/pages/envList.vue"),
  },
  {
    path: "/downloadPage",
    component: () => import("@/pages/DownloadPage.vue"),
  },
  {
    path: "/d",
    redirect: "/downloadPage",
  },
  {
    path: "/sharePage",
    component: () => import("@/pages/SharePage.vue"),
  },
  {
    path: "/globalEnv",
    component: () => import("@/pages/ModuleEnv.vue"),
  },
  {
    path: "/env",
    component: () => import("@/pages/GrapeEnv.vue"),
  },
  {
    path: "/ShareStock",
    component: () => import("@/pages/ShareStock.vue"),
  },
  {
    path: "/sysPerm",
    component: sysPermMgmt,
  },
  {
    path: "/about",
    component: About,
  },
  {
    path: "/iframe",
    component: Iframe,
  },
  {
    path: "/feedback",
    component: Feedback,
  },
  {
    path: "/logoff",
    component: LogOff,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path === "/home") {
    document.title = "模块版本切换";
  } else if (to.path === "/globalEnv") {
    document.title = "全局环境切换";
  } else if (to.path === "/env") {
    document.title = "青提环境切换";
  }
  next();
});
export default router;
